import { isSSR } from '../../../helpers/utils';

export class ChecklistStyles {
  public static getBaseStyles() {
    return isSSR ? { ...this.base, ...this.baseSSR } : this.base;
  }

  private static base: Partial<CSSStyleDeclaration> = {
    listStyleType: 'none',
  };

  private static baseSSR: Partial<CSSStyleDeclaration> = {
    margin: '10px 10px 10px 6px',
  };
}

export class ChecklistItemStyles {
  public static base: Partial<CSSStyleDeclaration> = {
    position: 'relative',
  };

  public static checked: Partial<CSSStyleDeclaration> = {
    textDecoration: 'line-through',
  };

  public static notChecked: Partial<CSSStyleDeclaration> = {
    textDecoration: 'none',
  };
}

type CheckboxOverwriteStyles = Pick<CSSStyleDeclaration, 'border' | 'background'>;
export class CheckboxStyles {
  public static notChecked: CheckboxOverwriteStyles = {
    border: '2px solid #718497',
    background: 'transparent',
  };

  public static base: Partial<CSSStyleDeclaration> = {
    height: '15px',
    width: '15px',
    borderRadius: '50%',
    display: 'inline-block',
    verticalAlign: 'text-bottom',
  };

  public static getContainerStyles() {
    return isSSR ? this.containerSSR : this.container;
  }

  public static getCheckedStyles() {
    return isSSR ? { ...this.checked, ...this.checkedSSR } : this.checked;
  }

  private static container: Partial<CSSStyleDeclaration> = {
    position: 'absolute',
    left: '-20px',
  };

  private static containerSSR: Partial<CSSStyleDeclaration> = {
    float: 'left',
    marginRight: '5px',
  };

  private static checked: CheckboxOverwriteStyles = {
    border: '2px solid #4fc510',
    background: `#4fc510 url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23fff' d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3E%3C/svg%3E") center/130%`,
  };

  private static checkedSSR: Pick<CheckboxOverwriteStyles, 'background'> = {
    background: `#4fc510 url("https://recruitee-assets.s3.eu-central-1.amazonaws.com/system-emails/assets/checkmark-612ab405bc0a68ad79e3a08978e2b09d.png") center/100%`,
  };
}
